import type Immutable from 'immutable';

import type FieldTypeMapping from 'views/logic/fieldtypes/FieldTypeMapping';

const hasCustomFields = (widgetFields: Immutable.OrderedSet<string>, defaultFields: Array<FieldTypeMapping>) =>
  widgetFields
    .subtract(['message', 'timestamp'])
    .filter((field) => !defaultFields.find((lakeField) => lakeField.name === field)).size >= 1;

export default hasCustomFields;
